<template>
  <v-touch @swipeleft="swiperleft" @swiperight="swiperight" class="frame">
    <div class="container-box">
      <!-- 顶部 -->
      <div class="header">
        <tabBar class="tabBarStyle"></tabBar>
      </div>
      <!-- 内容 -->
      <div class="content">
        <div style="margin-bottom: 30px">
          <p
            style="
              padding-left: 10px;
              margin-top: 20px;
              color: rgb(16, 16, 16);
              opacity: 0.5;
              letter-spacing: 0.2rem;
            "
          >
            有好的产品你就来
          </p>
          <p
            style="
              font-size: 25px;
              font-weight: 600;
              padding-left: 10px;
              margin-top: 6px;
            "
          >
            全省招募优质产品
          </p>
          <p
            style="
              padding-left: 10px;
              margin-top: 6px;
              color: rgb(16, 16, 16);
              opacity: 0.5;
            "
          >
            Recruiting high-quality products throughout the province
          </p>
        </div>
        <div></div>
        <div class="headerChild">
          <swiperText></swiperText>
        </div>
        <div style="margin-top: 2px; background-color: #eee">
          <div style="padding-left: 10px; padding-right: 10px">
            <div
              style="
                font-size: 25px;
                font-weight: 600;
                margin-top: 10px;
                position: relative;
				width: 200px;
				margin-left: 20px;
				height: 60px;
				line-height: 60px;
              "
            >
              <div
                style="
                  position: absolute;
                  height: 6px;
                  width: 6px;
                  background-color: #9d1d1e;
                  border-radius: 100%;
                  left: -20px;
                  top: 50%;
                  transform: translateY(-50%);
                "
              ></div>
              商家合作招募涵
              <div
                style="
                  position: absolute;
                  height: 6px;
                  width: 6px;
                  background-color: #9d1d1e;
                  border-radius: 100%;
                  right: 6px;
                  top: 50%;
                  transform: translateY(-50%);
                "
              ></div>
            </div>
            <div style="margin-bottom: 20px; color: #8d8d8d">
              山哩数智科技有限公司现向所有贵州生态农业商家招募所有意向合作
            </div>
            <div>
              向部队、医院、高校、中央厨房、集团总部基地等大型集采中心输送贵州农家生态肉品、米面粮油、水果蔬菜、
              辣椒调味等地方农业生态优品，由山哩数智科技有限公司向合作商家集中采购。与山哩数智科技有限公司集采中心合作优势如下：
            </div>
            <div style="margin-top: 20px; margin-bottom: 20px;text-indent: 2em;">
              一，公司垫资集采:无需担心货品结算问题，公司直接垫资集采，公司具备2000万-2亿的垫资实力，即采即付;
            </div>
            <div style="margin-top: 20px; margin-bottom: 20px;text-indent: 2em;">
              二，公司集采中心:公司自2016年起整合贵州生态农业供应链及下游采购中心，有较强的供应链实力，对集采销售下游具备更多的经验优势;
            </div>
            <div style="margin-top: 20px; margin-bottom: 20px;text-indent: 2em;">
              三，公司运作稳定:山哩数智科技有限公司成立于2019年.公司前生为贵州好农哥生态农业有限公司(成立于2016年)，公司秉承“山里的就是好”产品理念，至今任保持公司创立初心，经过多年的经验累积，具备更强的供应链行业服务(售前、售中、售后)
              优势。
            </div>
          </div>
          <img
            src="../../assets/hzgy-bj4.png"
            style="height: 100%; width: 100%"
          />
          <img
            src="../../assets/cpzx.jpg"
            @click="cpzxClick()"
            style="height: 100%; width: 100%"
          />
        </div>
        <form class="form" @submit.prevent="submitForm">
          <h2 class="form-title"></h2>
          <div class="form-group">
            <label for="name">您的姓名:</label>
            <input
              type="text"
              id="name"
              v-model="name"
              placeholder="请输入您的姓名"
              required
            />
          </div>
          <div class="form-group">
            <label for="phone">联系电话:</label>
            <input
              type="tel"
              id="phone"
              v-model="phone"
              placeholder="请输入您的联系电话"
              required
            />
          </div>
          <div class="form-group">
            <label for="project">项目名称:</label>
            <input
              type="text"
              id="project"
              v-model="project"
              placeholder="请输入您的项目名称"
              required
            />
          </div>
          <div class="form-group">
            <label for="cooperation">合作内容:</label>
            <textarea
              id="cooperation"
              v-model="cooperation"
              placeholder="请您描述想合作的项目及合作内容"
              required
            ></textarea>
          </div>
          <button type="submit">提交合作意向</button>
        </form>
      </div>
      <fixedBottomRight></fixedBottomRight>
    </div>
  </v-touch>
</template>

<script>
import tabBar from "../../assembly/tabBarNew.vue";
import swiper from "../../assembly/mobileSwiperNew.vue";
import swiperText from "@/components/iphone/test.vue";
import fixedBottomRight from "@/assembly/fixedBottomRight.vue";
import { submitCooperation } from "../../api/home.js";
export default {
  name: "introduce",
  data() {
    return {
      name: "",
      phone: "",
      project: "",
      cooperation: "",
      tabBarTitle: "",
      tabBarTitle1: "",
      introduceFont: `\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩数智科技有限公司（简称“山哩数智”）成立于2022年5月，是一家专注于个贷不良资产智能化运营的科技创新型企业。公司以“数智科技+大数据”为双引擎，为个贷不良资产提供全产业链管理服务。
公司自主研发的“E法通”智能系统，基于S2B2C案源供应链模式，集资产评估、智能分案与司法调解于一体，构建了覆盖全流程的数字化解决方案。
作为山哩控股集团的核心业务主体，山哩数智已完成全国化战略布局，控股河北、湖南、安徽、陕西、河南、江苏、广西等多家区域子公司，形成覆盖全国的规模化运营网络。`,
      enterpriseVision: "引领新消费、新经济、新业态;让中国新经济产业走向世界",
      governmentFont:
        "\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩科技的快速成长, 离不开党和国家的各项优惠政策, 更离不开各级政府领导的亲切关怀。公司成立以来各级政府领导多次对公司进行业务指导, 并对山哩科技的发展给予高度的肯定和赞赏, 鼓舞着山哩人乘风破浪勇往直前",
      list: [
        {
          url: require("@/assets/deve1.png"),
          title: "2013",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0项目以京东合伙人, 阿里生鲜、京东生鲜供应商的形式落地贵州毕节黔西。",
        },
        {
          url: require("@/assets/deve2.png"),
          title: "2014",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0京东生鲜正式纳入贵州项目, 正式启动京东黔西县特产馆。",
        },
        {
          url: require("@/assets/deve3.png"),
          title: "2015",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0项目成功获得西南地区阿里、京东生鲜的唯一供应商。",
        },
        {
          url: require("@/assets/deve4.png"),
          title: "2016",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0正式与黔西县人民政府签署战略合作, 成立好农哥生态农业有限公司",
        },
        {
          url: require("@/assets/deve5.png"),
          title: "2017",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩优品品牌发起, 累计销售额突破20亿元, 细分赛道国内前三名",
        },
        {
          url: require("@/assets/deve6.png"),
          title: "2018",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa02018年7月山哩优品电商品牌正式与京东脱离",
        },
        {
          url: require("@/assets/deve7.png"),
          title: "2019",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0独立运营, 寻求合作伙伴, 以最佳的现货交易模式做全国顶尖的订单农业电商品牌",
        },
        {
          url: require("@/assets/deve8.png"),
          title: "2020",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0通过VIE架构在美国纳斯达克上市。山哩成为该年度以SPAC主板上市企业",
        },
        {
          url: require("@/assets/deve9.png"),
          title: "2021",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0完成了A轮的3亿元人民币融资, 开启了向纳斯达克主板上市之路",
        },
      ],
      name: "",
      email: "",
      // 设置一些图片的链接
      images: [
        "https://picsum.photos/id/10/500/300",
        "https://picsum.photos/id/20/500/300",
        "https://picsum.photos/id/30/500/300",
        "https://picsum.photos/id/40/500/300",
      ],
      // 设置一些swiper的选项
      swiperOptions: {
        // 开启分页指示器
        pagination: {
          el: ".swiper-pagination",
        },
        // 开启循环播放
        loop: true,
        // 开启自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
      },
    };
  },
  components: {
    tabBar,
    swiper,
    swiperText,
    fixedBottomRight,
  },
  methods: {
    swiperleft() {
      /* this.$router.push({
					name: 'journalism'
				}) */
    },
    swiperight() {
      /* this.$router.push({
					name: 'introduce'
				}) */
    },
    cpzxClick() {
      this.$router.push({
        name: "productCenter",
      });
    },
    submitForm() {
      const sysCooperation = {
        name: this.name,
        phone: this.phone,
        project: this.project,
        cooperation: this.cooperation,
      };
      submitCooperation(sysCooperation).then((res) => {
        if (res.code == 200) {
          this.name = "";
          this.phone = "";
          this.project = "";
          this.cooperation = "";
          this.$message({
            message: "提交成功",
            type: "success",
            offset: window.screen.height / 2,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.frame {
  position: absolute;
  height: 100%;
  width: 100%;
  touch-action: pan-y !important;
}

.container-box {
  display: flex;
  flex-direction: column;

  .imgStyle {
    height: 100%;
    width: 100%;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: fixed;
    background-color: #fff;
    height: 7.5vh;
    width: 100%;
    z-index: 999;
    opacity: 0.85;

    .headerChild {
      height: 59%;
      width: 100vw;
    }

    .tabBarFontFrame {
      pointer-events: none;
      color: #fff;
      height: 5vh;
      width: 100%;
      position: absolute;
      top: 24vh;
      z-index: 3;
      display: flex;
      align-items: center;
      flex-direction: column;

      .tabBarFont {
        letter-spacing: 2px;
        font-weight: bold;
        font-size: 1.3rem;
      }

      .tabBarFont1 {
        margin-top: 2%;
        font-size: 1rem;
        letter-spacing: 2px;
      }
    }
  }

  .content {
    margin-top: 7.5vh;
    width: 100vw;

    .form {
      display: flex;
      flex-direction: column;
      /* align-items: center; */
      padding: 10px;
      border-radius: 5px;
      max-width: 100%;
    }

    .form-title {
      font-size: 28px;
      margin-bottom: 20px;
      text-align: center;
    }

    .form-group {
      margin: 10px 0;
      display: flex;
      flex-direction: column;
      max-width: 100%;
    }

    label {
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 10px;
      display: inline-block;
      width: 120px;
    }

    input[type="text"],
    input[type="tel"],
    textarea {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 5px;
      font-size: 16px;
      width: 100%;
      max-width: 100%;
    }

    input[type="text"],
    input[type="tel"] {
      margin-left: 20px;
    }

    button[type="submit"] {
      background-color: #008cba;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 5px;
      font-size: 16px;
      cursor: pointer;
      margin-top: 20px;
      max-width: 100%;
      transition: background-color 0.3s ease-in-out;
    }

    button[type="submit"]:hover {
      background-color: #004c8c;
    }

    @media only screen and (max-width: 600px) {
      .form-title {
        font-size: 24px;
      }

      label {
        font-size: 16px;
      }

      input[type="text"],
      input[type="tel"],
      textarea {
        font-size: 14px;
      }

      input[type="text"],
      input[type="tel"] {
        margin-left: 0;
        margin-top: 10px;
      }
    }
  }

  .IntroduceTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 10vh;

    .IntroduceTitleBg {
      height: 65%;
      width: 30%;
      background-color: rgb(179, 108, 108);
    }

    .IntroduceTitleFont {
      z-index: 3;
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #7b0000;
      flex-wrap: nowrap;
      display: flex;
      width: 100%;

      .IntroduceTitleFontChild {
        font-weight: bold;
        font-size: 1.3rem;
      }

      .IntroduceTitleFontChild1 {
        font-size: 0.5rem;
      }
    }
  }
}

.swiper-pagination-bullets {
  left: !important 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/iphone/cooperation.vue